document.addEventListener("DOMContentLoaded", () => {
  var swiperInstances = [];
  var $swiperSelector = $(".swiper-container");

  $swiperSelector.each(function (index) {
    var $this = $(this);
    $this.addClass("swiper-slider-" + index);

    // 🔧 Auto-assign nav classes to buttons in the same parent container
    const $parent = $this.closest(".swiper-slider"); // or adjust this to your wrapper class
    $parent.find(".swiper-button-next").addClass("swiper-nav-" + index);
    $parent.find(".swiper-button-prev").addClass("swiper-nav-" + index);
    
    var autoPlay = $this.data("auto-play")
      ? {
          delay: 7500, // Auto-scroll every 7.5 seconds to keep LCP stable on initial load
          disableOnInteraction: false, // Keep auto-scroll active even after user interaction
        }
      : false;
    var dragSize = $this.data("drag-size") ? $this.data("drag-size") : 50;
    var freeMode = $this.data("free-mode") ? $this.data("free-mode") : false;
    var loop = $this.data("loop") ? $this.data("loop") : false;
    var slidesDesktop = $this.data("slides-desktop")
      ? $this.data("slides-desktop")
      : 4;
    var slidesTablet = $this.data("slides-tablet")
      ? $this.data("slides-tablet")
      : 3;
    var slidesMobile = $this.data("slides-mobile")
      ? $this.data("slides-mobile")
      : 1.5;
    var spaceBetween = $this.data("space-between")
      ? $this.data("space-between")
      : 60;

    var swiper = new Swiper(".swiper-slider-" + index, {
      autoplay: autoPlay,
      direction: "horizontal",
      loop: loop,
      freeMode: freeMode,
      spaceBetween: spaceBetween,
      centeredSlides: false,
      disableOnInteraction: false,
      watchOverflow: true,
      breakpoints: {
        1280: {
          slidesPerView: slidesDesktop,
        },
        767: {
          slidesPerView: slidesTablet,
          spaceBetween: 20,
        },
        320: {
          slidesPerView: slidesMobile,
          spaceBetween: 10,
        },
      },
      pagination: {
        el: ".swiper-slider-" + index + " .swiper-pagination", // Target the pagination element
        clickable: true, // Allow users to click on dots
      },
      navigation: {
        // nextEl: ".swiper-slider-" + index + " .swiper-button-next",
        // prevEl: ".swiper-slider-" + index + " .swiper-button-prev",

         // 🔧 FIX: Search for buttons globally (outside container)
        nextEl: ".swiper-button-next.swiper-nav-" + index,
        prevEl: ".swiper-button-prev.swiper-nav-" + index,
      },
      scrollbar: {
        el: ".swiper-slider-" + index + " .swiper-scrollbar",
        draggable: true,
        dragSize: dragSize,
      },
      
    });

    swiperInstances.push(swiper);
  });

  $(".nav-tabs a").on("click", function (e) {
    $swiperSelector.each(function (index) {
      swiperInstances[index].update(); // Update swiper for the active tab
    });
  });

  $(document).on('shown.bs.collapse', function () {
  // Loop through all swiper selectors
    $swiperSelector.each(function (index) {
      swiperInstances[index].update(); // Update swiper for the active collapse
    });
  });
});

const recWrapper = document.querySelector("product-recommendations");

if (recWrapper) {
  const observer = new MutationObserver(() => {
    const $newSwiper = $(recWrapper).find(".swiper-container");

    if ($newSwiper.length && !$newSwiper.hasClass("swiper-initialized")) {
      $newSwiper.each(function (index) {
        var $this = $(this);
        $this.addClass("swiper-slider-" + index + " swiper-initialized"); // prevent double init

        var autoPlay = $this.data("auto-play")
          ? {
              delay: 2000,
              disableOnInteraction: false,
            }
          : false;
        var dragSize = $this.data("drag-size") ? $this.data("drag-size") : 50;
        var freeMode = $this.data("free-mode")
          ? $this.data("free-mode")
          : false;
        var loop = $this.data("loop") ? $this.data("loop") : false;
        var slidesDesktop = $this.data("slides-desktop")
          ? $this.data("slides-desktop")
          : 4;
        var slidesTablet = $this.data("slides-tablet")
          ? $this.data("slides-tablet")
          : 3;
        var slidesMobile = $this.data("slides-mobile")
          ? $this.data("slides-mobile")
          : 1.5;
        var spaceBetween = $this.data("space-between")
          ? $this.data("space-between")
          : 60;

        var swiper = new Swiper(".swiper-slider-" + index, {
          autoplay: autoPlay,
          direction: "horizontal",
          loop: loop,
          freeMode: freeMode,
          spaceBetween: spaceBetween,
          breakpoints: {
            1280: {
              slidesPerView: slidesDesktop,
            },
            767: {
              slidesPerView: slidesTablet,
              spaceBetween: 30,
            },
            320: {
              slidesPerView: slidesMobile,
              spaceBetween: 30,
            },
          },
          pagination: {
            el: ".swiper-slider-" + index + " .swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: ".swiper-slider-" + index + " .swiper-button-next",
            prevEl: ".swiper-slider-" + index + " .swiper-button-prev",
          },
          scrollbar: {
            el: ".swiper-slider-" + index + " .swiper-scrollbar",
            draggable: true,
            dragSize: dragSize,
          },
        });

        swiperInstances.push(swiper);
      });

      observer.disconnect(); // stop watching
    }
  });

  observer.observe(recWrapper, {
    childList: true,
    subtree: true,
  });
}

// FAQS
$(".faq-question").on("click", function () {
  $(".faq-answer").removeClass("active");
  //$(this).parent().addClass('active');
  $(this).parent().toggleClass("active");

  $(this).next().slideToggle();
  $(this).parent().siblings().removeClass("active");
  $(this).parent().siblings().find(".faq-answer").slideUp("active");
});

// Detect when the page is scrolled past the header
window.addEventListener("scroll", function () {
  const navbarCollapse = document.querySelector(".navbar-collapse");
  const header = document.querySelector(".page-width");

  // Check if the header has reached the sticky state
  if (window.scrollY > header.offsetHeight) {
    // If the header is sticky, change the `top` value for navbar-collapse
    navbarCollapse.classList.add("sticky-header");
  } else {
    // If the header is not sticky, reset the `top` value for navbar-collapse
    navbarCollapse.classList.remove("sticky-header");
  }
});






window.onload = function () {
  //setTimeout(() => {
  document.querySelectorAll(".panels").forEach((panel) => {
    if (
      panel.nextElementSibling &&
      panel.nextElementSibling.tagName.toLowerCase() === "p"
    ) {
      panel.nextElementSibling.style.setProperty(
        "display",
        "none",
        "important"
      );
    }
  });
  //}, 0); // Runs after 5 seconds
};

// open External Links in New Tab
document.addEventListener("DOMContentLoaded", function () {
  const siteHostname = window.location.hostname;
  const links = document.querySelectorAll('a[href^="http"]'); // Only absolute URLs

  links.forEach((link) => {
    const linkHostname = new URL(link.href).hostname;

    if (linkHostname !== siteHostname) {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer"); // for security
    }
  });
});

//Smooth Scrolling
document.addEventListener("DOMContentLoaded", () => {
  const headerHeight = 140;

  function smoothScrollToId(id) {
    const targetElement = document.getElementById(id);
    if (targetElement) {
      const elementPosition =
        targetElement.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  }



  //Toggle your product layout between grid view (col-lg-4 col-6) and row view

  const gridBtn = document.getElementById("grid-btn");
  if (gridBtn) {
    gridBtn.addEventListener("click", function () {
      const rows = document.querySelectorAll("#product-grid .row");

      rows.forEach((row) => {
        const children = row.children;
        for (let i = 0; i < children.length; i++) {
          children[i].classList.remove("col-6");
          children[i].classList.add("col-lg-3", "col-md-4","col-6");
        }
      });
    });
  }

  const rowBtn = document.getElementById("row-btn");
  if (rowBtn) {
    rowBtn.addEventListener("click", function () {
      const rows = document.querySelectorAll("#product-grid .row");

      rows.forEach((row) => {
        const children = row.children;
        for (let i = 0; i < children.length; i++) {
          children[i].classList.remove("col-lg-3", "col-md-4","col-6");
          children[i].classList.add("col-12");
        }
      });
    });
  }


  // Replace the | with <br> in footer scoket
  function updateFooterSeparator() {
    const footer = document.getElementById("footer-socket");
    if (!footer) return;

    let content = footer.innerHTML;

    // Replace | and <br> depending on screen width
    if (window.innerWidth < 992) {
      // Clean up all &nbsp;
      content = footer.innerHTML.replace(/&nbsp;/g, " ");
      content = content.replace(/\s*\|\s*/, "<br>");
    } else {
      content = content.replace(/<br\s*\/?>/, " | ");
    }

    footer.innerHTML = content;
  }

  // Run on load
  updateFooterSeparator();

  // Run on resize
  window.addEventListener("resize", updateFooterSeparator);

});

// Countdown timer (e.g. announcement bar offers)
document.addEventListener("DOMContentLoaded", function () {
  const countdownEls = document.querySelectorAll("[data-countdown-end]");
  if (!countdownEls.length) return;

  function updateCountdowns() {
    countdownEls.forEach(function (el) {
      const endTime = new Date(el.getAttribute("data-countdown-end")).getTime();
      const diff = endTime - Date.now();

      if (isNaN(endTime) || diff <= 0) {
        el.textContent = "Offer Ended";
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);

      const parts = [];
      if (days > 0) parts.push(days + "D");
      parts.push(String(hours).padStart(2, "0") + "H");
      parts.push(String(minutes).padStart(2, "0") + "M");

      el.textContent = parts.join(" ");
    });
  }

  updateCountdowns();
  setInterval(updateCountdowns, 30000);
});

// Open main menu dropdowns on hover (desktop/mouse only, click still works on touch)
document.addEventListener("DOMContentLoaded", function () {
  const hoverCapable = window.matchMedia("(hover: hover) and (pointer: fine)");
  const dropdowns = document.querySelectorAll(".navbar-main .nav-item.dropdown");

  dropdowns.forEach(function (dropdown) {
    const toggleEl = dropdown.querySelector('[data-bs-toggle="dropdown"]');
    if (!toggleEl || typeof bootstrap === "undefined") return;

    const bsDropdown = bootstrap.Dropdown.getOrCreateInstance(toggleEl);
    let closeTimeout;

    dropdown.addEventListener("mouseenter", function () {
      if (!hoverCapable.matches) return;
      clearTimeout(closeTimeout);
      bsDropdown.show();
    });

    dropdown.addEventListener("mouseleave", function () {
      if (!hoverCapable.matches) return;
      closeTimeout = setTimeout(function () {
        bsDropdown.hide();
      }, 150);
    });
  });
});

// Adjust / Calculate the main menu position
document.addEventListener("shown.bs.dropdown", function (e) {
  console.log("Dropdown opened");

  const nav = document.querySelector(".navbar-main"); // your navbar
  const parentDropdown = e.target.closest(".dropdown"); // find parent
  const dropdown = parentDropdown?.querySelector(".dropdown-menu"); // find menu

  if (nav && dropdown) {
    const rect = nav.getBoundingClientRect();
    const zoom = parseFloat(getComputedStyle(document.documentElement).zoom) || 1;
    dropdown.style.top = rect.bottom / zoom + "px";
  } else {
  }
});


/************************ WISHLIST ***********************
*
*  WISHLIST -- COLLECTION
*  WISHLIST -- PDP
*  WISHLIST -- BUBBLE ICON
*  WISHLIST -- PAGE
* 
***********************************************************/

// Wishlist
document.addEventListener('DOMContentLoaded', function () {
  const favoriteIcons = document.querySelectorAll('.favorite-icon');
  const favorites = JSON.parse(localStorage.getItem('favorites')) || [];


  //handle the buble icon
  if(favorites.length > 0){
    //document.querySelector('.wishlist-count-bubble').style.display = 'block';
    //document.querySelector('.wishlist-count-bubble > span').innerText = favorites.length;
  }else{
    //document.querySelector('.wishlist-count-bubble').style.display = 'none';
  }

  
  // Mark already favorited products as active
  favoriteIcons.forEach(icon => {
    const productHandle = icon.getAttribute('data-product-handle');
    if (favorites.includes(productHandle)) {
      icon.classList.add('active');
      icon.querySelector('svg').width = '25.91';
      icon.querySelector('svg').height = '22.95';
      icon.querySelector('svg path').style.fill = '#FFACDB';
      icon.querySelector('svg path').style.fillOpacity  = '1';
    }
  });

  // Handle click on the favorite icon
  favoriteIcons.forEach(icon => {
    icon.addEventListener('click', function () {
      const productHandle = this.getAttribute('data-product-handle');
      const isActive = this.classList.contains('active');

      if (isActive) {
        const index = favorites.indexOf(productHandle);
        if (index > -1) {
          favorites.splice(index, 1);
        }
        this.classList.remove('active');
        this.querySelector('svg').width = '24.24';
        this.querySelector('svg').height = '21.47';
        this.querySelector('svg path').style.fill = '#BAB3B3';
        this.querySelector('svg path').style.fillOpacity  = '0.78';
       
      } else {
        favorites.push(productHandle);
        this.classList.add('active');
         this.querySelector('svg').width = '25.91';
        this.querySelector('svg').height = '22.95';
        this.querySelector('svg path').style.fill = '#FFACDB';
        this.querySelector('svg path').style.fillOpacity  = '1';
      }

      localStorage.setItem('favorites', JSON.stringify(favorites));

       //handle the buble icon
      if(favorites.length > 0){
        //document.querySelector('.wishlist-count-bubble').style.display = 'block';
        //document.querySelector('.wishlist-count-bubble > span').innerText = favorites.length;
      }else{
        //document.querySelector('.wishlist-count-bubble').style.display = 'none';
      }
    });
  });


  /********* ONLY FOR PDP *********/
  const favoriteIconsProducts = document.querySelectorAll('.dst-wishlist-icon-product');
  

  // Mark already favorited products as active
  favoriteIconsProducts.forEach(icon => {
    const productHandle1 = icon.getAttribute('data-product-handle');
    if (favorites.includes(productHandle1)) {
      icon.classList.add('active');
      icon.querySelector('svg path').style.fill = '#000';
      icon.querySelector('svg path').style.stroke = '#000';
      icon.querySelector('svg path').style.fillOpacity  = '1';
    }
  });

  // Handle click on the favorite icon
  favoriteIconsProducts.forEach(icon => {
    icon.addEventListener('click', function () {
      const productHandle = this.getAttribute('data-product-handle');
      const isActive = this.classList.contains('active');

      if (isActive) {
        const index = favorites.indexOf(productHandle);
        if (index > -1) {
          favorites.splice(index, 1);
        }
        this.classList.remove('active');
        this.querySelector('svg path').style.fill = 'none';
         this.querySelector('svg path').style.stroke = '#000';
        this.querySelector('svg path').style.fillOpacity  = '1';
       
      } else {
        favorites.push(productHandle);
        this.classList.add('active');
        this.querySelector('svg path').style.fill = '#000';
        this.querySelector('svg path').style.stroke = '#000';
        this.querySelector('svg path').style.fillOpacity  = '1';
      }

      localStorage.setItem('favorites', JSON.stringify(favorites));

       //handle the buble icon
      if(favorites.length > 0){
        //document.querySelector('.wishlist-count-bubble').style.display = 'block';
        //document.querySelector('.wishlist-count-bubble > span').innerText = favorites.length;
      }else{
        //document.querySelector('.wishlist-count-bubble').style.display = 'none';
      }
      
    });
  });

});

document.addEventListener('DOMContentLoaded', function () {
  const wishlistContainer = document.querySelector('.wishlist-items');
  const favorites = JSON.parse(localStorage.getItem('favorites')) || [];
  if (wishlistContainer) {
    if (favorites.length === 0 && wishlistContainer) {
      wishlistContainer.innerHTML = '<p class="empty-wishlist">Your wishlist is empty.</p>';
      return;
    }

    wishlistContainer.classList.add('wishlist-grid'); // Add grid styling class

    favorites.forEach(handle => {
      fetch(`/products/${handle}.json`)
        .then(response => response.json())
        .then(product => {
          const p = product.product;
          const hasHidePriceTag = p.tags && p.tags.includes('Hide Price');

          const productHtml = `
            <div class="wishlist-card">
              <a href="/products/${handle}" class="wishlist-image">
                <img src="${p.image ? p.image.src : ''}" alt="${p.title}" loading="lazy">
              </a>
              <div class="wishlist-info">
                <h3 class="wishlist-title">
                  <a href="/products/${handle}">${p.title}</a>
                </h3>

                ${
                  !hasHidePriceTag
                    ? `<p class="wishlist-price f--blue f--1_125rem mf-1rem f--bold-600">
                        Start From: $${p.variants[0].price}
                      </p>`
                    : ``
                }

                <div class="wishlist-actions">
                  <a href="/products/${handle}" class="btn view-product">
                    <span class="f--1_125rem mf--1rem f--black-ori f--bold-500">
                      View Product
                    </span>
                  </a>

                  <button class="remove-wishlist"
                    data-product-handle="${handle}"
                    aria-label="Remove from wishlist">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.3718 1L1.37183 13M13 13L1 1"
                        stroke="black" stroke-width="1.8"
                        stroke-linejoin="round">
                      </path>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          `;
          wishlistContainer.insertAdjacentHTML('beforeend', productHtml);
        });
    });
  }
});

//localStorage.removeItem('favorites');
// Remove the Single Item
setTimeout(function(){
  document.querySelectorAll('.remove-wishlist').forEach(button => {
  button.addEventListener('click', function() {
    const productHandleRemove = this.getAttribute('data-product-handle');

    // Remove the item from the wishlist (e.g., update the wishlist in localStorage or call your app's API)
    removeFavoriteByHandle(productHandleRemove);

    // Optionally, remove the item from the DOM
    this.closest('.wishlist-card').remove();
  });
});

function removeFavoriteByHandle(productHandle) {
  // Get the current favorites from localStorage
  let favorites = JSON.parse(localStorage.getItem('favorites')) || [];

  // Find the index of the productHandle in the favorites array
  const index = favorites.indexOf(productHandle);

  // If the productHandle exists in the favorites, remove it
  if (index > -1) {
    favorites.splice(index, 1); // Remove the item from the array
  }

  // Update the favorites in localStorage
  localStorage.setItem('favorites', JSON.stringify(favorites));
  //handle the buble icon
    if(favorites.length > 0){
      // document.querySelector('.wishlist-count-bubble').style.display = 'block';
      // document.querySelector('.wishlist-count-bubble > span').innerText = favorites.length;
    }else{
      //document.querySelector('.wishlist-count-bubble').style.display = 'none';
    }
}
}, 1000);



 jQuery(document).ready(function() {
    var brandsList = $('[data-brands-list]'),
        brand = brandsList.find('.brand');

    brand.each(function() {
      var self = jQuery(this),
          brandTitle = self.find('.azbrands-title h3').text().trim(),
          character = self.find("ul.brand-grid li:eq(0) a").text().charAt(0).toLowerCase(),
          alphabet = brandsList.prev(),
          alphabetChild = alphabet.children();

      alphabetChild.each(function() {
        var aElm = jQuery(this).find('a');
        
        if(aElm.text().trim().toLowerCase() == brandTitle) {
          if(!aElm.hasClass('readonly')) 
            aElm.addClass('readonly');
          return; 
        }; 
      });
      if(!self.find('.azbrands-title').length) {
        self.find('.brand-grid').children().appendTo('.brand-' + character + " ul.brand-grid");
        self.remove();
      }      
    });

    var vendorItem = brandsList.prev().find('.vendor-letter a.readonly');
    
    vendorItem.on('click', function() {
      var selfText = jQuery(this).text().trim().toLowerCase();
      
      brand.hide().filter(function(e){
        var title =  jQuery(this).find('.azbrands-title h3').text().trim().toLowerCase();
        
        if(title == selfText) {
          jQuery(this).show();          
          return;
        };        
      });
      
      jQuery('.azbrandstable .all-brand a').click(function(){
        brand.show();
      });
    });
    
    var allVendor = brandsList.prev().find('a.readonly');
    
    allVendor.on('click', function() {
      brandsList.prev().find('a').removeClass('active');
      
      var self = jQuery(this);
      
      if(!self.hasClass('active')) {
        self.addClass('active');
      };
      
      var offsetTop = brandsList.prev('.azbrandstable').offset().top;
      
      // jQuery('body,html').animate({
      //   scrollTop: offsetTop
      // }, 600);
    });

    var newURL = location.href.split("#")[1];

    jQuery('.vendor-letter .' + newURL).trigger('click');
    jQuery('.vendor-letter-menu a').on('click', function(){
      var url = jQuery(this).attr('href').split("#")[1];
      jQuery('.vendor-letter .' + url).trigger('click');
    });
  });



//  // Run after a delay (simulate late form load)
//     setTimeout(() => {
//       // Select all forms
//       const forms = document.querySelectorAll("form");

//       forms.forEach(form => {
//         const fields = form.querySelectorAll("input, select, textarea, button");

//         // Assign tabIndex sequentially
//         fields.forEach((field, index) => {
//           field.tabIndex = index + 1;
//         });

//         // Add keyboard shortcut: press Enter to move to next field
//         form.addEventListener("keydown", function(e) {
//           if (e.key === "Enter") {
//             e.preventDefault(); // prevent form submit
//             const currentIndex = Array.from(fields).indexOf(document.activeElement);
//             const nextField = fields[currentIndex + 1];
//             if (nextField) {
//               nextField.focus();
//             }
//           }
//         });
//       });
//     }, 3000); // wait 3 seconds before applying

setTimeout(() => {
  // Select all forms
  const forms = document.querySelectorAll("form");

  forms.forEach(form => {
    // Select only visible, non-hidden fields
    const fields = Array.from(
      form.querySelectorAll("input:not([type='hidden']), select, textarea, button")
    ).filter(el => el.offsetParent !== null); // ignore hidden by CSS

    // Assign tab index inside this form only
    fields.forEach((field, index) => {
      field.tabIndex = index + 1;
    });

    // Add Enter-key navigation inside this form only
    form.addEventListener("keydown", function (e) {
      if (e.key === "Enter") {
        e.preventDefault();

        const currentIndex = fields.indexOf(document.activeElement);

        if (currentIndex !== -1) {
          const nextField = fields[currentIndex + 1];
          if (nextField) nextField.focus();
        }
      }
    });
  });
}, 3000);


document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.getElementById('Search-In-Template');
  const searchForm = searchInput.closest('form');

  searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
          e.preventDefault(); // prevent predictive search from taking over
          searchForm.submit(); // submit the form
      }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.querySelector('.search__input.field__input');
  if (!searchInput) return;

  const searchForm = searchInput.closest('form');

  searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
          e.preventDefault(); // prevent predictive search from taking over
          searchForm.submit(); // submit the form
      }
  });
});


 document.addEventListener('DOMContentLoaded', function () {
    const originalBtn = document.querySelector('.product-form__submit');
    const stickyBar = document.querySelector('.sticky-atc');

    if (!originalBtn || !stickyBar) return;

    const observer = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          stickyBar.style.display = 'none';
        } else {
          stickyBar.style.display = 'block';
        }
      },
      { threshold: 0 }
    );

    observer.observe(originalBtn);
  });

  document.querySelector('.sticky-atc-btn')?.addEventListener('click', function () {
    document.querySelector('.product-form__submit').click();
  });


// Free shipping bar
document.addEventListener('DOMContentLoaded', function () {
  const freeShippingThreshold = 15000; // $150 in cents

  function updateFreeShippingProgress(cartTotal) {
    const progressBar = document.querySelector('.progress-bar .progress');
    const freeShippingMessage = document.querySelector('.free-shipping-message');

    if (!progressBar || !freeShippingMessage) return;

    if (cartTotal >= freeShippingThreshold) {
      freeShippingMessage.textContent = 'Qualified for free shipping ($150)';
      progressBar.style.width = '100%';
    } else {
      const remainingAmount = (freeShippingThreshold - cartTotal) / 100;
      freeShippingMessage.textContent = `$${remainingAmount.toFixed(2)} away from Free Shipping!`;
      progressBar.style.width = `${(cartTotal / freeShippingThreshold) * 100}%`;
    }
  }

  function fetchCartDataAndUpdateProgress() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        updateFreeShippingProgress(cart.total_price);
      })
      .catch(err => console.error('Cart fetch error:', err));
  }

  // ✅ Intercept ALL fetch requests
  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    const url = args[0];

    // 👇 Only react to cart-related requests
    if (
      typeof url === 'string' &&
      (url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/clear'))
    ) {
      // wait a bit for Shopify to finish updating
      setTimeout(fetchCartDataAndUpdateProgress, 300);
    }

    return response;
  };

  // ✅ Initial load
  fetchCartDataAndUpdateProgress();
});

// Free shipping bar End